// FIFA World Cup 2026 Stadium Data
export const STADIUMS = [
  {
    id: 'vancouver',
    name: 'BC Place',
    city: 'Vancouver',
    country: 'Canada',
    address: '777 Pacific Blvd, Vancouver (BC) V6B 4Y8, Canada',
    capacity: 48821,
    mapUrl: 'https://digitalhub.fifa.com/m/3c2acc012b1bae34/original/Stadium_Map_Vancouver.png',
    keywords: ['vancouver', 'bc place', 'pacific']
  },
  {
    id: 'toronto',
    name: 'BMO Field',
    city: 'Toronto',
    country: 'Canada',
    address: "170 Princes' Blvd, Toronto (ON) M6K 3C3, Canada",
    capacity: 44315,
    mapUrl: 'https://digitalhub.fifa.com/m/2256877ea4883936/original/Stadium_Map_Toronto.png',
    keywords: ['toronto', 'bmo field', 'princes']
  },
  {
    id: 'mexico_city',
    name: 'Estadio Azteca',
    city: 'Mexico City',
    country: 'Mexique',
    address: 'Calz. de Tlalpan 3465, Sta. Úrsula Coapa, Coyoacán, 04650 Ciudad de México, CDMX, Mexique',
    capacity: 72766,
    mapUrl: 'https://digitalhub.fifa.com/m/6724a8924837d6a7/original/Stadium_Map_Mexico_City.png',
    keywords: ['mexico', 'azteca', 'ciudad de mexico', 'cdmx', 'mexico city']
  },
  {
    id: 'guadalajara',
    name: 'Estadio Akron',
    city: 'Guadalajara',
    country: 'Mexique',
    address: 'Circuito J.V.C. 2800, El Bajío, 45014 Zapopan, Jalisco, Mexique',
    capacity: 44330,
    mapUrl: 'https://digitalhub.fifa.com/m/34606c01376b9858/original/Stadium_Map_Guadalajara.png',
    keywords: ['guadalajara', 'akron', 'zapopan', 'jalisco']
  },
  {
    id: 'monterrey',
    name: 'Estadio BBVA',
    city: 'Monterrey',
    country: 'Mexique',
    address: 'Av. Pablo Livas 2011, colonia La Pastora, C.P. 67140, en Guadalupe, Nuevo León, Mexique',
    capacity: 50113,
    mapUrl: 'https://digitalhub.fifa.com/m/470e53caa32491a7/original/Stadium_Map_Monterrey.png',
    keywords: ['monterrey', 'bbva', 'nuevo leon']
  },
  {
    id: 'atlanta',
    name: 'Mercedes-Benz Stadium',
    city: 'Atlanta',
    country: 'USA',
    address: '1 AMB Dr NW, Atlanta, GA 30313, États-Unis',
    capacity: 67382,
    mapUrl: 'https://digitalhub.fifa.com/m/7b28137545c45610/original/Stadium_Map_Atlanta.png',
    keywords: ['atlanta', 'mercedes', 'georgia']
  },
  {
    id: 'boston',
    name: 'Gillette Stadium',
    city: 'Boston',
    country: 'USA',
    address: '1 Patriot Pl, Foxborough, MA 02035, États-Unis',
    capacity: 63815,
    mapUrl: 'https://digitalhub.fifa.com/m/5414e729dc079316/original/Stadium_Map_Boston.png',
    keywords: ['boston', 'gillette', 'foxborough', 'massachusetts']
  },
  {
    id: 'dallas',
    name: 'AT&T Stadium',
    city: 'Dallas',
    country: 'USA',
    address: '1 AT&T Way, Arlington, TX 76011, États-Unis',
    capacity: 70122,
    mapUrl: 'https://digitalhub.fifa.com/m/2a8fd5552a3bf728/original/Stadium_Map_Dallas.png',
    keywords: ['dallas', 'att', 'arlington', 'texas']
  },
  {
    id: 'houston',
    name: 'NRG Stadium',
    city: 'Houston',
    country: 'USA',
    address: 'NRG Pkwy, Houston, TX 77054, États-Unis',
    capacity: 68311,
    mapUrl: 'https://digitalhub.fifa.com/m/428702d2f199975e/original/Stadium_Map_Houston.png',
    keywords: ['houston', 'nrg', 'texas']
  },
  {
    id: 'kansas_city',
    name: 'Arrowhead Stadium',
    city: 'Kansas City',
    country: 'USA',
    address: '1 Arrowhead Dr, Kansas City, MO 64129, États-Unis',
    capacity: 67513,
    mapUrl: 'https://digitalhub.fifa.com/m/598ce151095d8adf/original/Stadium_Map_Kansas_City.png',
    keywords: ['kansas', 'arrowhead', 'missouri']
  },
  {
    id: 'los_angeles',
    name: 'SoFi Stadium',
    city: 'Los Angeles',
    country: 'USA',
    address: '1001 Stadium Dr, Inglewood, CA 90301, États-Unis',
    capacity: 69650,
    mapUrl: 'https://digitalhub.fifa.com/m/2b3d1983e7d1f7bb/original/Stadium_Map_Los_Angeles.png',
    keywords: ['los angeles', 'sofi', 'inglewood', 'california', 'la']
  },
  {
    id: 'miami',
    name: 'Hard Rock Stadium',
    city: 'Miami',
    country: 'USA',
    address: '347 Don Shula Dr, Miami Gardens, FL 33056, États-Unis',
    capacity: 64091,
    mapUrl: 'https://digitalhub.fifa.com/m/81896f00a53e020/original/Stadium_Map_Miami.png',
    keywords: ['miami', 'hard rock', 'florida', 'miami gardens']
  },
  {
    id: 'new_york',
    name: 'MetLife Stadium',
    city: 'New York / New Jersey',
    country: 'USA',
    address: '1 MetLife Stadium Dr, East Rutherford, NJ 07073, États-Unis',
    capacity: 78576,
    mapUrl: 'https://digitalhub.fifa.com/m/6547f6ac676326c4/original/Stadium_Map_New_York_New_Jersey.png',
    keywords: ['new york', 'new jersey', 'metlife', 'east rutherford', 'nj', 'ny']
  },
  {
    id: 'philadelphia',
    name: 'Lincoln Financial Field',
    city: 'Philadelphia',
    country: 'USA',
    address: 'One Lincoln Financial Field Way, Philadelphia, PA 19148, États-Unis',
    capacity: 65827,
    mapUrl: 'https://digitalhub.fifa.com/m/87ef914bd38349c/original/Stadium_Map_Philadelphia.png',
    keywords: ['philadelphia', 'lincoln', 'pennsylvania', 'philly']
  },
  {
    id: 'san_francisco',
    name: "Levi's Stadium",
    city: 'San Francisco Bay Area',
    country: 'USA',
    address: '4900 Marie P DeBartolo Way, Santa Clara, CA 95054, États-Unis',
    capacity: 69391,
    mapUrl: 'https://digitalhub.fifa.com/m/74e37ec670ea784f/original/Stadium_Map_San_Francisco_Bay_Area.png',
    keywords: ['san francisco', 'santa clara', 'levis', 'bay area', 'california']
  },
  {
    id: 'seattle',
    name: 'Lumen Field',
    city: 'Seattle',
    country: 'USA',
    address: '800 Occidental Ave S, Seattle, WA 98134, États-Unis',
    capacity: 65123,
    mapUrl: 'https://digitalhub.fifa.com/m/aeb01f8007b3494/original/Stadium_Map_Seattle.png',
    keywords: ['seattle', 'lumen', 'washington']
  }
];

// Find stadium by venue/city name
export const findStadium = (lieu, ville) => {
  const searchText = `${lieu || ''} ${ville || ''}`.toLowerCase();
  
  for (const stadium of STADIUMS) {
    // Check keywords
    for (const keyword of stadium.keywords) {
      if (searchText.includes(keyword.toLowerCase())) {
        return stadium;
      }
    }
    // Check city name
    if (searchText.includes(stadium.city.toLowerCase())) {
      return stadium;
    }
  }
  
  return null;
};

export default STADIUMS;
